export default __webpack_public_path__ + "static/media/vivek_event.2dc34595.png";